"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class CampaignEmailTemplate extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "CampaignEmailTemplate";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/campaigns/" +
      this.id +
      "/templates"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create campaign email template.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    console.error("Cannot update campaign email template.");
  }

  getAdminPath() {
    console.error("Cannot go to a campaign email template..");
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultTitle() {
    return this.displayName;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default CampaignEmailTemplate;
